import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AuthLayout } from "./AuthLayout";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { InlineSpinner } from "@/components/common/Loading";
import { CheckCircle2, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() }); setDone(true); }
    catch (err) { setError(apiError(err)); }
    finally { setLoading(false); }
  };

  if (done) {
    return (
      <AuthLayout title="Check your email" subtitle="If an account exists, a reset link is on its way.">
        <div className="flex flex-col items-center text-center py-4" data-testid="reset-sent">
          <CheckCircle2 className="w-12 h-12 text-emerald-500 mb-3" />
          <p className="text-sm text-slate-600">We sent a password reset link to <strong>{email}</strong>. It expires in 1 hour.</p>
          <Link to="/login" className="mt-6 text-sm text-[#0093D6] font-medium hover:underline">Back to sign in</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Reset your password" subtitle="Enter your email and we'll send you a reset link.">
      <form onSubmit={submit} className="space-y-4">
        {error && <p className="text-sm text-rose-600" data-testid="auth-error">{error}</p>}
        <div>
          <Label htmlFor="email" className="text-xs font-semibold text-slate-700">Email</Label>
          <Input id="email" type="email" value={email} required data-testid="forgot-email"
            onChange={(e) => setEmail(e.target.value)} className="mt-1.5" placeholder="you@company.com" />
        </div>
        <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-[#006090] hover:bg-[#004E75]">
          {loading ? <InlineSpinner /> : "Send reset link"}
        </Button>
        <Link to="/login" className="flex items-center justify-center gap-1 text-sm text-slate-500 hover:text-slate-700">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
      </form>
    </AuthLayout>
  );
}
